.dotted-divider {
    border-bottom: 1px dashed var(--grey-lt);
    width: 100%;
    margin: 32px 0;
}

.preview-top-bar {
    box-sizing: border-box;
    width: 100%;
    height: 90px;
    padding: 12px;
    border-bottom: 1px solid var(--off-white-dk);
    background-color: var(--white);
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
}
